import { render, staticRenderFns } from "./UserProfileContactPrefs.vue?vue&type=template&id=74841d06&"
import script from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
export * from "./UserProfileContactPrefs.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileContactPrefs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VContainer,
  VFlex,
  VForm,
  VLayout,
  VProgressCircular,
  VRadio,
  VRadioGroup,
  VSpacer,
})
